import React from 'react';

const FloatingInput = ({ label, name, type = "text", value, onChange, error, icon: Icon, ...props }) => {
  // توليد ID فريد للربط بين الـ Label والـ Input
  const inputId = `input-${name || label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className="relative w-full mb-1">
      <div className="relative flex items-center">
        
        {/* عرض الأيقونة إذا تم تمريرها — استخدام start/ps بدل left/pl عشان
            تتقلب تلقائي مع اتجاه اللغة (rtl للعربي) بدل ما تفضل ثابتة على
            الشمال زي ما كانت. */}
        {Icon && (
          <div className="absolute start-4 z-2 pointer-events-none text-gray-400 peer-focus:text-[var(--primary-color)] transition-colors">
            {/* هنا نستخدم <Icon /> كمكون React */}
            <Icon className="w-5 h-5" />
          </div>
        )}

        <input
          {...props}
          type={type}
          id={inputId}
          value={value}
          onChange={onChange}
          placeholder=" "
          className={`peer w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-gray-50/50
          rounded-xl border-2 transition-all outline-none focus:outline-none focus:ring-0
          ${error ? 'border-red-400 focus:border-red-500' : 'border-gray-100 focus:border-[var(--primary-color)]'}
          ${Icon ? 'ps-12' : 'ps-4'}`} // زيادة الـ Padding إذا وجدت أيقونة
        />

        <label
          htmlFor={inputId}
          className={`absolute text-xs font-bold uppercase tracking-widest transition-all duration-200
          cursor-text pointer-events-auto
          peer-placeholder-shown:text-sm peer-placeholder-shown:font-medium peer-placeholder-shown:lowercase
          peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs peer-focus:font-bold peer-focus:uppercase
          top-2 text-gray-400 peer-focus:text-[var(--primary-color)]
          ${Icon ? 'start-12' : 'start-4'}
          ${value ? 'top-2 text-xs font-bold uppercase' : ''}`}
        >
          {label}
        </label>
      </div>

      {error && (
        <p className="text-[10px] text-red-500 font-bold mt-1 ms-2 uppercase tracking-tight">
          {error}
        </p>
      )}
    </div>
  );
};

export default FloatingInput;